// extracted by mini-css-extract-plugin
export var Instruction = "styles-module--Instruction--uxkG5";